export default "__VITE_PUBLIC_ASSET__f3149cf6__"